const { convertArrayToCSV } = require('convert-array-to-csv');
import exportProjectNameMapper from './ExportProjectNameMapper'

const NO_SELECTION_LABEL = '(No selection)';

const exportDemographicsCSVMapper = (projectData, reportData) => {
  // Handle nested report structure from API response
  const report = reportData?.data?.report || reportData?.report || reportData;
  const {exportFileName} = exportProjectNameMapper(projectData, 'Descriptors')
  const header = ['Descriptor', 'Option', 'Number of Transcripts']

  const descriptors = report?.descriptors || [];
  const rows = descriptors.flatMap((descriptor) => [
    ...(descriptor.multi_choices || []).map((multiChoice) => [
      descriptor.name,
      multiChoice.choice,
      multiChoice.transcript_count,
    ]),
    [descriptor.name, NO_SELECTION_LABEL, descriptor.no_selection_count],
  ]);

  return {
    projectName: exportFileName,
    demographicsText: convertArrayToCSV(rows, {
      separator: ',',
      header: header
    })
  }
}

export default exportDemographicsCSVMapper
